import React from 'react';
import '../Message.css';
const errorMessage = (props) => (
    <div className="alert-msg-bg">
        <div className="d-flex">
            <i className="material-icons alert-icon-bg">remove_circle</i>
            <span className="ml20 alert-msg-text">{props.message}</span>
        </div>
    </div>)

 export default errorMessage; 
